import React, { memo } from 'react';

import Icon from 'components/Icon';
import { ItemViewerName, ItemViewerArrow, ItemViewerWrapper } from './styles';
import { IItemPicker } from 'store/entity/types';
import { getProviderIcon } from 'store/providers/providerTypes';
import { languageDirection } from '../../../i18n';

interface IComponentProps {
  file: IItemPicker;
  onSelectAItem: (
    item: IItemPicker
  ) => (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  isItemSelected: boolean;
  onLoadMoreItems: (
    item: IItemPicker
  ) => (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onDoubleClickNoneFolder: (item: IItemPicker) => void;
}

const ItemViewer: React.FC<IComponentProps> = ({
  file,
  onSelectAItem,
  isItemSelected,
  onLoadMoreItems,
  onDoubleClickNoneFolder,
}) => {
  const { name, type } = file;
  return (
    <ItemViewerWrapper
      onClick={onSelectAItem(file)}
      selected={isItemSelected}
      onDoubleClick={
        type === 'folder'
          ? onLoadMoreItems(file)
          : () => onDoubleClickNoneFolder(file)
      }
    >
      <Icon type={getProviderIcon[type]} />
      <ItemViewerName>{name}</ItemViewerName>
      {type === 'folder' && (
        <ItemViewerArrow
          type={
            languageDirection() === 'rtl' ? 'chevron-left' : 'chevron-right'
          }
          onClick={onLoadMoreItems(file)}
        />
      )}
    </ItemViewerWrapper>
  );
};

export default memo(ItemViewer);
